import type { Track } from "../types";
import { redirectToDownload } from "../config/appConfig";

const RECENT_KEY = "ym_recent_tracks";
const DOWNLOAD_KEY = "ym_downloaded_tracks";
const LIMIT = 50;

function read(key: string): Track[] {
  try {
    if (typeof localStorage?.getItem !== "function") return [];
    const value = JSON.parse(localStorage.getItem(key) || "[]");
    return Array.isArray(value) ? value : [];
  } catch {
    return [];
  }
}

function write(key: string, tracks: Track[]) {
  try {
    if (typeof localStorage?.setItem !== "function") return;
    localStorage.setItem(key, JSON.stringify(tracks.slice(0, LIMIT)));
    window.dispatchEvent(new CustomEvent("ym:library-change"));
  } catch {
    // Playback must keep working when storage is blocked or unavailable.
  }
}

export const localLibrary = {
  recent: () => read(RECENT_KEY),
  downloads: () => read(DOWNLOAD_KEY),
  recordRecent(track: Track) {
    write(RECENT_KEY, [track, ...read(RECENT_KEY).filter((item) => item.id !== track.id)]);
  },
  recordDownload(track: Track) {
    write(DOWNLOAD_KEY, [track, ...read(DOWNLOAD_KEY).filter((item) => item.id !== track.id)]);
  },
  removeDownload(id: number) {
    write(DOWNLOAD_KEY, read(DOWNLOAD_KEY).filter((item) => item.id !== id));
  },
};

export function downloadTrack(_track?: Track) {
  redirectToDownload();
  return true;
}

